import { FC } from 'react';

import { HotColumn } from '@handsontable/react';
import { IList } from 'core/API/listApi';
import { MSearchProductHeader, translateHeaders } from './helpers/HeadersList';
import Grid from '../Grid';
import { AutoCompleteRenderer } from './helpers/customRenderers';
import { eanValidator, listValidator } from '../Validators';
import { requireTitle } from './helpers/utils';

export const MSearchProduct: FC<{
    list: IList;
    toolId: number;
    keywords: string[];
}> = ({ list, toolId, keywords }) => {
    const translatedHeaders = translateHeaders(MSearchProductHeader);

    return (
        <Grid toolId={toolId} headers={MSearchProductHeader} list={list}>
            <HotColumn title={requireTitle(translatedHeaders[0])} validator={eanValidator(false)} />
            <HotColumn
                validator={listValidator(keywords, false)}
                title={requireTitle(translatedHeaders[1])}
                source={keywords}
                type="autocomplete"
            >
                <AutoCompleteRenderer allowEmpty={false} list={keywords} hot-renderer />
            </HotColumn>
            <HotColumn type="text" title={translatedHeaders[2]} />
        </Grid>
    );
};
